module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Bold.d197a963.woff2";